import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import GainSlider from '../GainSlider/GainSlider.tsx'

interface VolumeBarProps {
  volume: number
  setVolume: (volume: number) => void
}

const VolumeBar: React.FC<VolumeBarProps> = ({ setVolume, volume }) => {
  const { t } = useTranslation()

  const handleChange = useCallback(
    (gainDb: number) => {
      setVolume(gainDb)
    },
    [setVolume]
  )

  return (
    <div className="mx-auto w-full max-w-md">
      <div className="mb-1 flex items-center justify-between">
        <p className="text-xs font-medium text-white">{t('ls_volume')}</p>
      </div>
      <GainSlider value={volume} onChange={handleChange} />
    </div>
  )
}

export default React.memo(VolumeBar)
